import { ThemeProvider } from "@mui/material/styles";

import { Alert, Box, Modal } from "@mui/material";
import {
  DataGridPro,
  GridPaginationModel,
  useGridApiRef,
} from "@mui/x-data-grid-pro";
import themeInarix from "../StylesMuiInarix";
import userDevicesColumns from "./userDevicesFetchingColumns";
import { useDispatch, useSelector } from "react-redux";
import { UserDevicesBody } from "./EditDeviceModal";
import { SuccessGeneralModal } from "../SuccessModal";
import { State } from "../../redux/slices";
import { useState } from "react";
import SearchComponent from "../customFilterComponent/searchComponent";
import { CustomFilterButton } from "../customFilterComponent/customFilterButton";
import { TFunction } from "i18next";
import { ThunkDispatch } from "@reduxjs/toolkit";
import {
  setFilterModel,
  setPreselectedFilterField,
  setShowFilterForm,
} from "../../redux/slices/fleet/devices";
import { DevicesStyles } from "./DevicesStyles";
import customFilterStyles from "../customFilterComponent/customFiltersStyles";

const SetActions = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  return {
    /// custom filter component
    setFilterModel: (filterModel: any) => {
      dispatch(setFilterModel(filterModel));
    },

    setShowFilterForm: (show: boolean) => {
      dispatch(setShowFilterForm(show));
    },

    setPreselectedFilterField: (field: string | null) => {
      dispatch(setPreselectedFilterField(field));
    },
  };
};

export function UserDevicesTable(
  t: (arg0: string) => string,
  token: string,
  locale: string,
  setRowsNumber: (value: GridPaginationModel) => void,
  tabName: string,
) {
  const apiRef = useGridApiRef();
  const [quickFilterValue, setQuickFilterValue] = useState("");
  const { setFilterModel, setShowFilterForm, setPreselectedFilterField } =
    SetActions();

  const {
    devices,
    loading,
    modal,
    error,
    errorPatch,
    deviceName,
    msg,
    loadingPatch,
    deviceId,
    filterModel,
    showFilterForm,
    preselectedFilterField,
  } = useSelector((state: State) => state.DevicesReducer);
  const successBodyModal = SuccessGeneralModal(t, tabName);
  const bodyUserDevices = UserDevicesBody(
    t,
    token,
    devices,
    deviceId,
    deviceName,
    errorPatch,
    loadingPatch,
  );

  const handleQuickFilterChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    setQuickFilterValue(value);

    if (apiRef.current) {
      apiRef.current.setQuickFilterValues(value ? [value] : []);
    }
  };

  const { columns, devicesRows } = userDevicesColumns(t);

  return (
    <Box sx={DevicesStyles.container}>
      {error && errorPatch !== 400 && (
        <div className="container alert-content-devices">
          <Alert severity="warning" className="alert-content-devices">
            {t("Fleet_users.table.Error")} : {JSON.stringify(error)}
          </Alert>
        </div>
      )}

      <div style={customFilterStyles.filterContainer}>
        <SearchComponent
          t={t}
          quickFilterValue={quickFilterValue}
          handleQuickFilterChange={handleQuickFilterChange}
        />
        <div style={DevicesStyles.containerFilterButon}>
          <CustomFilterButton
            t={t as TFunction<"global", undefined>}
            isDisabled={false}
            loadingsValues={false}
            filterModel={filterModel}
            setShowFilterForm={setShowFilterForm}
            showFilterForm={showFilterForm}
            setPreselectedFilterField={setPreselectedFilterField}
            preselectedField={preselectedFilterField}
            columnsTable={columns}
            setFilterModel={setFilterModel}
            handleApplyFilters={() => {}}
            hasNoData={false}
          />
        </div>
      </div>

      <ThemeProvider theme={themeInarix(locale)}>
        <DataGridPro
          apiRef={apiRef}
          className="table-styles-alone"
          disableColumnSelector={true}
          rows={devicesRows}
          columns={columns}
          rowHeight={78}
          loading={loading}
          pagination
          onPaginationModelChange={(newPageSize) => setRowsNumber(newPageSize)}
          pageSizeOptions={[25, 50, 100]}
          initialState={{
            pagination: { paginationModel: { pageSize: 25 } },
          }}
        />
      </ThemeProvider>
      <Modal open={modal}>{bodyUserDevices}</Modal>
      <Modal open={msg}>{successBodyModal}</Modal>
    </Box>
  );
}
